module.exports = __webpack_public_path__ + "img/s4-3.0d20675c.jpg";